import { gql } from "@apollo/client";

export default gql`
  mutation DeclineGroupRequest($requestId: ObjectId!) {
    declineGroupRequest(requestId: $requestId)
  }
`;
